import { Typography } from '@mui/material'

const TableHeaderTitle = ({ title }: { title: string }) => {
    return (
        <Typography
            sx={{
                zIndex: '100',
                position: 'relative',
                maxWidth: { xs: '100%', sm: '350px' },
                fontSize: { xs: '18px', sm: '19px', md: '20px' },
                marginBottom: '0px',
                fontWeight: 'medium',
            }}
            variant="h3"
            gutterBottom
        >
            {title}
        </Typography>
    )
}

export default TableHeaderTitle